module.exports = __webpack_public_path__ + "img/shopee-icon.220e96d0.png";